<ng-container *ngIf="!isDesktop else desktop">
    <div *ngIf="tournamentIndex>-1" class="tournament-container" (click)="openTournamentDialog()">
        <div class="my-position">{{myPosition || '- - -'}}</div>
        <img src="assets/playbison/icon_tournaments-174x174.png" />
    </div>
</ng-container>
<ng-template #desktop>
    <div *ngIf="tournamentIndex>-1" class="leaderboard" (click)="openTournamentDialog()">
        <img src="{{licenceService.getKey('icon-tournament-info')}}">
        <span i18n>Leaderboard</span>
    </div>
</ng-template>